import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MilestoneService } from '../../../../../_services/milestone/milestone.service';
import { MilestoneEvent } from '../../../../../_models/milestone/milestone-event.model';
import { ErrorModalHelperService } from '../../../../../_helpers/error-modal-helper/error-modal-helper.service';
import { SuccessModalHelperService } from '../../../../../_helpers/success-modal-helper/success-modal-helper.service';

export interface MilestoneModalData {
  placementId: number;
  studentId: number;
  studentName?: string;
}

/**
 * Create a learner milestone event from the student card. Save-only (delete happens in the timeline
 * view per the story); Cancel is a no-op that makes no request. Mirrors LeapV2ConsultantNotesDialog.
 */
@Component({
  selector: 'milestone-modal',
  templateUrl: './milestone-modal.component.html',
  standalone: false,
})
export class MilestoneModalComponent {
  public eventDate: string;
  public eventDescription = '';
  public saving = false;
  public readonly maxLength = 500;

  constructor(
    public dialogRef: MatDialogRef<MilestoneModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MilestoneModalData,
    private milestoneService: MilestoneService,
    private errorModalHelper: ErrorModalHelperService,
    private successModalHelper: SuccessModalHelperService
  ) {
    // Default to today, using the local calendar day (not UTC) for the yyyy-MM-dd date input.
    this.eventDate = this.toDateInputValue(new Date());
  }

  public get canSave(): boolean {
    return !this.saving
      && this.eventDate != null && this.eventDate !== ''
      && this.eventDescription.trim().length > 0
      && this.eventDescription.length <= this.maxLength;
  }

  public save(): void {
    if (!this.canSave) return;
    this.saving = true;
    const milestone: MilestoneEvent = {
      id: 0,
      placementId: this.data.placementId,
      studentId: this.data.studentId,
      eventDate: this.eventDate,
      eventDescription: this.eventDescription.trim(),
    };
    this.milestoneService.save(milestone).subscribe({
      next: () => {
        this.successModalHelper.show('Milestone event saved');
        this.dialogRef.close(true);
      },
      error: (error) => {
        this.saving = false;
        this.errorModalHelper.show(error.message, error);
      },
    });
  }

  private toDateInputValue(date: Date): string {
    const offsetMs = date.getTimezoneOffset() * 60000;
    return new Date(date.getTime() - offsetMs).toISOString().split('T')[0];
  }
}
